import BaseDropdown, { DropdownItem } from "@common/components/Dropdown/Dropdown";
import Input from "@common/components/Input/Input";
import { vars } from "@common/styles";
import * as Icons from "@main/pages/shared/icons/icons";
import styled, { css } from "styled-components";

export const ReleaseVersionDropdown = styled(BaseDropdown)`
  background: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey90};
  border-radius: 1rem;

  > div:first-child {
    padding: 1rem;
  }

  span {
    color: ${vars.colors.grey30};
    white-space: nowrap;
  }
`;

export const ReleaseVersionDropdownSearch = styled(Input)`
  > * {
    background-color: ${vars.colors.grey100};
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid ${vars.colors.grey90};
    border-radius: 0;
    padding: 1.3rem 1.6rem;
    max-height: 6.4rem;

    &:hover {
      border-bottom: 1px solid ${vars.colors.grey90};
    }
  }
`;

export const ReleasesDropdownItem = styled(DropdownItem)<{ $clicked?: boolean }>`
  ${(props) =>
    props.$clicked &&
    css`
      background: ${vars.colors.grey90};
    `}

  p {
    color: ${vars.colors.grey50};
    max-width: 22rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const dropdownScroll = `max-height: 25rem;`;

export const NoResultsText = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.2rem;
  padding: 1.4rem 1.8rem;
  color: ${vars.colors.grey50};
`;

export const Checkmark = styled.div`
  margin-right: 0.8rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
`;

export const CheckmarkIcon = styled(Icons.CheckmarkIcon)`
  path {
    stroke: ${vars.colors.white};
  }
`;
